import React, { useState, useRef, useEffect } from 'react';
import MarketPillars from './MarketPillars';
import Capabilities from './Capabilities';

// Connected "What We Do" experience: click a market pillar -> the capabilities
// section stretches open below to reveal that market's disciplines. Nothing in
// the capabilities block is shown until a pillar is chosen.
export default function WhatWeDo() {
  const [activeMarket, setActiveMarket] = useState(null);
  const capRef = useRef(null);

  const selectMarket = (id) => {
    setActiveMarket(id);
    setTimeout(() => {
      if (capRef.current) capRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 160);
  };

  // Navbar "Capabilities" link opens the section (defaults to "All" if no pillar
  // has been chosen yet) so it never scrolls to an empty section.
  useEffect(() => {
    const open = () => {
      setActiveMarket((prev) => (prev == null ? 'all' : prev));
      setTimeout(() => {
        if (capRef.current) capRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 220);
    };
    window.addEventListener('omc:open-capabilities', open);
    return () => window.removeEventListener('omc:open-capabilities', open);
  }, []);

  return (
    <>
      <MarketPillars onSelect={selectMarket} activeMarket={activeMarket} />
      <Capabilities ref={capRef} activeMarket={activeMarket} onMarketChange={setActiveMarket} />
    </>
  );
}
